module.exports = __webpack_public_path__ + "static/media/team.9dfc45c1.png";